/**
 * Module wise constants used across application.
 */
import Utils from './../app/utils';
const { baseUrl = '' } = Utils.getConfig();

const modules = (() => {
    return {
        DEVELOPMENT: 'dev',
        CONFIG_TOKENS: 'hotelConfigTokens',
        CLIENT_CONFIGURATION_CACHE: 'hotelConfigCache',
        CACHE_TOKENS: {
            HOTEL_CONFIG: 'hotel'
        },
        STATIC_BASE_URL: baseUrl,
        EVENT: {
            ACCORDION_SWITCH: 'ACCORDION_SWITCH'
        },
        ROLE: {
            ADMIN: "ADMIN",
            CALLCENTER: "CALLCENTER",
            SUPERVISOR: "SUPERVISOR",
            AGENT_STAFF: 'AGENT_STAFF',
            CORPORATE_STAFF: "CORPORATE_STAFF"
        },
        SORT: {
            RATING: 'starRating',
            PRICE: 'price',
            PREFFERED_HOTEL: 'prefHotel',
            LOCATION_SEARCH: 'locationFilter'
        },
        OVERLAY_TYPE: {
            FULL_SCREEN: "FULL_SCREEN",
            BOTTOM_SCREEN: "BOTTOM_SCREEN",
            FILTER_SCREEN: "FILTER_SCREEN"
        },
        FILTER: {
            RATING: 'ratings',
            USER_RATING:"userRating",
            PRICE: 'price',
            MEAL_BASIS: 'mealBasis',
            SUB_REGION: 'subRegion',
            PROPERTY_TYPE: 'propertyType',
            SUPPLIER_TYPE: 'supplierType',
            UNICA_ID: 'unicaId'
        },
        EVENT: {
            PRICE_FILTER_RESET: 'PRICE_FILTER_RESET',
            RATING_FILTER_RESET: 'RATING_FILTER_RESET',
            USER_FILTER_RESET:"USER_RATING_FILTER_RESET",
            MEAL_BASIS_FILTER_RESET: 'MEAL_BASIS_FILTER_RESET',
            SUB_REGION_FILTER_RESET: 'SUB_REGION_FILTER_RESET',
            PROPERTY_TYPE_FILTER_RESET: 'PROPERTY_TYPE_FILTER_RESET',
            WARNING_TOAST: 'WARNING_TOAST',
            UNICA_ID_FILTER_RESET: 'UNICA_ID_FILTER_RESET'
        }
    };
})();

export default modules;
